export const mapToken =
  'pk.eyJ1IjoiYXBsdXNzbW9zY293IiwiYSI6ImNqeXR6MGNyOTA4czEzY216NWM4MG9vZjcifQ.Ks7yZfpW4gW2LmlVYLHKgw'

export const tomtomToken = 'hS3VXfdf94TSrzpE4IHUGgVtGmYAs2eS'
